import type { FC } from 'react';
import { cn } from '../lib/utils';

interface LiveIndicatorProps {
  live: boolean;
  /** Defaults to `Flowing`. */
  liveLabel?: string;
  /** Defaults to `No data`. */
  idleLabel?: string;
  className?: string;
}

/** Whether data is arriving: a glowing brand dot, or a hollow ring when it isn't. */
export const LiveIndicator: FC<LiveIndicatorProps> = ({
  live,
  liveLabel = 'Flowing',
  idleLabel = 'No data',
  className
}) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5',
      live ? 'text-brand' : 'text-muted-foreground',
      className
    )}
  >
    <span
      aria-hidden="true"
      className={cn(
        'size-1.5 shrink-0 rounded-full',
        live ? 'bg-brand shadow-[0_0_6px_var(--z-brand)]' : 'border border-current'
      )}
    />
    {live ? liveLabel : idleLabel}
  </span>
);
